// extracted by mini-css-extract-plugin
export default {"con":"EnergyCertificate_con__KPHi8"};